<script>
    import {  getContext } from 'svelte';
    import { bind as bindModal } from 'svelte-simple-modal';
    import { modal } from 'src/stores.js'
    import ModalHeader from 'src/components/Modal/ModalHeader.svelte';
    import Loading from 'src/components/Loading.svelte';
    import {arrayUtils} from 'src/shared/arrayUtils.js';

    export let name = 'main';
    export let options;

    let defaultOptions = {
        closeOnOuterClick: false,
        styleWindow:{
            'padding-top':'1em',
            'padding-bottom':'1em'
        },
        styleContent:{
            'padding-top':'0em',
            'padding-bottom':'0em',
            //subtract the top and bottom padding of window from original 100vh-4rem
            'max-height':'calc(100vh - 4rem - 4rem)'
        },
        closeButton: ModalHeader
    };

    $: optionsWithDefaults = mergeOptions(options,defaultOptions);

    let context = getContext('simple-modal');

    $modal[name]  = context;
    $modal[name] = {close:context.close};
    if (name==='loading') {
        $modal.loading.open = function (props,overrideOptions) {
            return context.open(Loading,props,mergeOptions(overrideOptions,optionsWithDefaults));
        }
    } else {
        $modal[name].open = function (comp,props,overrideOptions) {
            return context.open(comp,props,mergeOptions(overrideOptions,optionsWithDefaults));
        }
    }

    function mergeOptions(options={},defaults={}) {
        let mergedOptions = {};
        let optionNames = arrayUtils.union(Object.keys(defaults),Object.keys(options));
        for (let optionName of optionNames) {
            if (/^transition|^style/.test(optionName)) {
                mergedOptions[optionName] = {...defaults[optionName],...options[optionName]};
            } else {
                mergedOptions[optionName] = optionName in options ? options[optionName] : defaults[optionName];
            }
        }
        //handle the close button thing in more custom way to add the title to header
        if (mergedOptions.closeButton) {
            mergedOptions.closeButton = bindModal(mergedOptions.closeButton,{title:mergedOptions.title});
        }
        //don't need have title in options passed back to caller. just wanted merged title to create closeButton
        delete mergedOptions.title;

        return mergedOptions;
    }

</script>
